import React from 'react';
import { Link } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';
import ShadowButton from './ShadowButton';


export default function Routinely() {
  return (
    <div className="wrapper max-w-5xl mx-auto px-4 my-6 sm:my-32 opacity-0 animate-fade-in-up animation-delay-400">
      {/* Hero Section */}
      <div className="flex flex-col md:flex-row gap-8 mb-12">
        <div className="md:w-2/3 w-full">
          <div className="flex items-center gap-3 mb-4">
            <div 
              className="w-12 h-12 flex items-center justify-center rounded text-white font-bold"
              style={{ backgroundColor: '#4b5563' }}
            >
              RL
            </div>
            <h1 className="text-3xl font-bold">Routinely</h1>
          </div>
          <p className="text-xl font-medium mb-6">
            Finding the perfect spot in the crowded skincare market for a data-driven skincare brand to grow.
          </p>
          
          <div className="flex flex-wrap gap-2 mb-8">
            {["Strategy", "D2C", "Beauty", "2021"].map(tag => (
              <span key={tag} className="px-3 py-1 bg-gray-100 text-gray-800 rounded-full text-sm">
                {tag}
              </span>
            ))}
          </div>
        </div>
        
        <div className="md:w-2/4 w-full">
          <img 
            src="assets/project-image-routinely.png" 
            alt="Routinely project" 
            className="w-full h-auto rounded-xl"
          />
        </div>
      </div>

      {/* Problem Section - Streamlined */}
      <div className="mb-12">
        <h2 className="text-2xl font-bold mb-4 flex items-center">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-6 h-6 mr-2">
            <path strokeLinecap="round" strokeLinejoin="round" d="M3 3v1.5M3 21v-6m0 0 2.77-.693a9 9 0 0 1 6.208.682l.108.054a9 9 0 0 0 6.086.71l3.114-.732a48.524 48.524 0 0 1-.005-10.499l-3.11.732a9 9 0 0 1-6.085-.711l-.108-.054a9 9 0 0 0-6.208-.682L3 4.5M3 15V4.5" />
            </svg>
          The challenge
        </h2>
        <p className="mb-4">
          Identifying the best European markets and customers to launch first.
        </p>
      </div>

      {/* My Role Section - With Image */}
      <div className="mb-12">
        <h2 className="text-2xl font-bold mb-4">My role</h2>
        
        <div className="flex flex-col md:flex-row gap-8">
          <div className="md:w-2/3 w-full">
            <p className="mb-4">
              As venture analyst, I mapped growth opportunities through:
            </p>
            
            <div className="space-y-4">
              <div>
                <h3 className="font-bold mb-2">Offering analysis</h3>
                <p>Analyzed 60+ competitors to map and define a unique positioning and recommend which benefits to prioritize.</p>
              </div>
              <div>
                <h3 className="font-bold mb-2">Brand & market evaluation</h3>
                <p>Conducted country-by-country analysis to identify optimal European launch markets and define an expansion roadmap.</p>
              </div>
            </div>
          </div>
          
          <div className="md:w-2/4 w-full">
            <img 
              src="assets/project-method-routinely.png" 
              alt="Market analysis visualization" 
              className="w-full h-auto rounded-xl shadow-lg"
            />
          </div>
        </div>
      </div>

      {/* Results Section - Streamlined */}
      <div className="mb-12">
        <h2 className="text-2xl font-bold mb-4">Results</h2>
        <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
          <div className="bg-gray-50 p-4 rounded-lg flex flex-col justify-center items-center text-center">
            <p className="text-2xl font-bold">60+</p>
            <p className="text-sm">Competitors analyzed</p>
          </div>
          <div className="bg-gray-50 p-4 rounded-lg flex flex-col justify-center items-center text-center">
            <p className="text-2xl font-bold">3</p>
            <p className="text-sm">Geographical growth strategies defined</p>
          </div>
          <div className="bg-gray-50 p-4 rounded-lg flex flex-col justify-center items-center text-center">
            <p className="text-2xl font-bold">8</p>
            <p className="text-sm">Priority cities defined</p>
          </div>
        </div>
      </div>

      {/* Key Wins - Streamlined */}
      <div className="mb-12">
        <h2 className="text-2xl font-bold mb-4">Key wins</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="bg-gray-50 p-4 rounded-lg flex">
            <svg className="w-6 h-6 mr-3 text-green-500 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
            </svg>
            <p>Comprehensive competitor radar</p>
          </div>
          <div className="bg-gray-50 p-4 rounded-lg flex">
            <svg className="w-6 h-6 mr-3 text-green-500 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
            </svg>
            <p>5 Key positioning insights confirmed</p>
          </div>
          <div className="bg-gray-50 p-4 rounded-lg flex">
            <svg className="w-6 h-6 mr-3 text-green-500 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
            </svg>
            <p>Data supported expansion strategy</p>
          </div>
        </div>
      </div>

      {/* Technologies - Streamlined */}
      <div className="mb-12">
        <h2 className="text-2xl font-bold mb-4">Technologies</h2>
        <div className="flex flex-wrap gap-2">
          {["Notion", "Excel", "Miro", "Keynote"].map(tech => ( 
            <span key={tech} className="px-3 py-1 bg-gray-100 text-gray-800 rounded-full text-sm">
              {tech}
            </span>
          ))}
        </div>
      </div>

      <div className="my-24 bg-gray-100 p-12 rounded-lg">
      <h2 className="text-2xl text-center font-bold mb-4">Do you have a similar challenge and want to work with me?</h2>
  
  <div className="flex flex-col sm:flex-row gap-3 justify-center">
            {/* Using ShadowButton component */}
            <ShadowButton href="mailto:christophe@vaneerdt.be" fullWidth>
              Email me
            </ShadowButton>
            <ShadowButton href="tel:+32479706342" fullWidth>
              Call me
            </ShadowButton>
            <ShadowButton href="https://www.linkedin.com/in/cvaneerdt/" fullWidth>
              LinkedIn
            </ShadowButton>
          </div> 
     
</div>

      {/* Navigation */}
      <div className="flex justify-between items-center pt-6 border-t border-gray-200">
        <Link to="/monthlies" className="flex items-center gap-2 text-gray-600 hover:text-gray-900">
          <span className="w-8 h-8 flex items-center justify-center rounded text-white font-bold text-sm" style={{ backgroundColor: '#E63946' }}>
            ML
          </span>
          <span>Previous: Monthlies</span>
        </Link>
      </div>
    </div>
  );
}